<article *ngIf="data"
         id="{{data.slug}}-feature-section"
         class="w-full md:h-auto py-5 md:py-7 flex justify-content-center align-items-center ci-bg--{{data?.color}}">
  <section *ngIf="data?.features?.length > 0"
           class="flex flex-row align-items-center gap-4 lg:gap-8">
    <section *ngFor="let item of data.features"
             class="flex flex-column gap-3 align-items-center">
      <section class="w-4rem h-4rem md:w-9rem md:h-9rem flex justify-content-center align-items-center p-3 border-circle border-white shadow-4"
               style="border: 4px solid;">
        <i class="bi {{item.icon}} text-4xl md:text-7xl ci-txt--white"></i>
      </section>

      <section class="max-w-20rem">
        <h5 class="text-center text-xl md:text-2xl ci-txt--white font-semibold">
          {{item.title}}
        </h5>
      </section>
    </section>
  </section>
</article>